import { Component, Vue } from 'vue-property-decorator';
import SideNavigation from '@/components/SideNavigation/SideNavigation';
import { performances } from '@/views/PerformanceShop/performanceList';
import TopDualLogo from '@/components/TopDualLogo/TopDualLogo'
import { request } from '@/tools/request.ts';
import uuidv1 from 'uuid';
import * as query from 'query-string';
import LogoBar from '@/components/LogoBar/LogoBar'

@Component<PerformanceShop>({
  components: {
    SideNavigation,
    TopDualLogo,
    LogoBar,
  },
})
export default class PerformanceShop extends Vue {
  protected perfomanceList: any = [];
  protected showVideoDialog: boolean = false;
  protected baseUrl: string = process.env.VUE_APP_API_BASE_ENDPOINT || 'https://us-central1-api-solution.cloudfunctions.net/webApi/api/v1/';
  protected paymentUrl: string = this.baseUrl + 'elastos/payments/';
  protected pricingData: any = {
    qrCodeUrl: '',
    price: 1.0,
    unit: 'ELA'
  };
  protected currentPerformance: any =  {
    playTime: '',
    title: '',
    artist: '',
    location: '',
    image: '',
    uuid: '',
  };
  protected performanceInformation: any = {
    label: {
      name: 'Manteca records, inv',
      society: 'NA',
    }, 
    publisher: {
      contact: 'NA',
      name: 'SonyATV',
    }, 
    recordingArtist: {
      name: 'Beth Orthon',
    }
  };

  public mounted() {
    this.getVideos();
  }

  protected getVideos() {
    request('get', this.baseUrl + 'metadataTracks').then(
      (response: any) => {
        this.perfomanceList = response.data;
        this.parseVideoInformationValues();
      },
      (error: any) => {
        console.log('request error', error);
      }
    );
  }
  protected getPricingData(performance: any) {
    const params = query.stringify({
      video: performance.id,
      orderid: performance.uuid
    });
    request('get', this.paymentUrl + 'pricing?' + params).then(
      (response: any) => {
        this.pricingData = response.data;
        if (this.pricingData && response.data) {
          this.pricingData.qrcode = this.paymentUrl + response.data.qrcode;  
        }
      },
      (error: any) => {
        console.log('request error', error);
      }
    );
  }
  protected addView(performance: any) {
    let encrypt: boolean = true;

    let payload: any = {
      band: performance.data.general.name,
      deviceID: 'client',
      ipAddress: 'client',
      source: 'client',
      timeStamp: Math.floor(Date.now() / 1000),
      // video: performance.id,
      video: `${performance.data.general.name} - ${performance.data.general.songTitle}`,
      uuid: performance.uuid || undefined
    }
    
    if (this.$store.state.userLocation) {
      payload['gpsCords'] = {
        lat: this.$store.state.userLocation.latitude,
        long: this.$store.state.userLocation.longitude,
      }
    }

    request('post', this.baseUrl +  'views', payload, encrypt).then(
      (response: any) => {
        console.log('request response', response);
      },
      (error: any) => {
        console.log('request error', error);
      }
    );
  }

  parseVideoInformationValues() {
    this.perfomanceList.forEach((item: any) => {
      item['information'] = {};
      for (let key in item.data) {
        item.information[key] = {};
        for (let nestedKey in item.data[key]) {
          if (typeof item.data[key][nestedKey] === 'object') {
            item.information[key] = {...item.information[key], ...item.data[key][nestedKey]};
          } else {
            item.information[key][nestedKey] = item.data[key][nestedKey];
          }
        }
      }

    });
  }

  protected parseIfArray(value: any) {
    if (!Array.isArray(value)) return value;
    else return value.join(', ');
  }

  protected goToVideo(performance: any) {
    if (!performance) 
      return;
    // deep copy
    this.currentPerformance = JSON.parse(JSON.stringify(performance));
    this.currentPerformance.uuid = uuidv1();
    this.showVideoDialog = true;
    // TODO: Wait for payment received and then start video and register the view
    // probably should be a promise
    this.getPricingData(this.currentPerformance);
    this.addView(this.currentPerformance);
    // this.$router.push(`performance-shop/${id}`);
  }
}
